import React from 'react'
import { Route, Redirect } from 'react-router'
import Loadable from 'react-loadable'
import loading from 'components/ui/Loader/Loader'

// const EmptyLayout             = Loadable({ loader: () => import('layers/marketplace/containers/EmptyLayout/EmptyLayout'), loading })
// const RegisterPage            = Loadable({ loader: () => import('layers/marketplace/pages/RegisterPage/RegisterPage'), loading })

const AreaLayout              = Loadable({ loader: () => import('layers/marketplace/containers/AreaLayout/AreaLayout'), loading })
const PageLayout              = Loadable({ loader: () => import('layers/marketplace/containers/PageLayout/PageLayout'), loading })
const AuthLayout              = Loadable({ loader: () => import('layers/marketplace/containers/AuthLayout/AuthLayout'), loading })
const AdminLayout             = Loadable({ loader: () => import('layers/marketplace/containers/AdminLayout/AdminLayout'), loading })
const CashierLayout           = Loadable({ loader: () => import('layers/marketplace/containers/CashierLayout/CashierLayout'), loading })
const CustomerLayout          = Loadable({ loader: () => import('layers/marketplace/containers/CustomerLayout/CustomerLayout'), loading })
const AccessLayout            = Loadable({ loader: () => import('layers/marketplace/containers/AccessLayout/AccessLayout'), loading })

const PrivacyPage             = Loadable({ loader: () => import('layers/marketplace/pages/PrivacyPage/PrivacyPage'), loading })

// SuperAdmin
const AdminAreaConfigPage     = Loadable({ loader: () => import('layers/marketplace/pages/admin/sport/AdminAreaConfigPage/AdminAreaConfigPage'), loading })

// Admin sport
const AdminLearnPage          = Loadable({ loader: () => import('layers/marketplace/pages/admin/sport/AdminLearnPage/AdminLearnPage'), loading })
const AdminReportPage         = Loadable({ loader: () => import('layers/marketplace/pages/admin/sport/AdminReportPage/AdminReportPage'), loading })
const AdminTicketPage         = Loadable({ loader: () => import('layers/marketplace/pages/admin/sport/AdminTicketPage/AdminTicketPage'), loading })
const AdminTariffPage         = Loadable({ loader: () => import('layers/marketplace/pages/admin/sport/AdminTariffPage/AdminTariffPage'), loading })
const AdminSchedulePage       = Loadable({ loader: () => import('layers/marketplace/pages/admin/sport/AdminSchedulePage/AdminSchedulePage'), loading })
const AdminStatisticsPage     = Loadable({ loader: () => import('layers/marketplace/pages/admin/sport/AdminStatisticsPage/AdminStatisticsPage'), loading })
const AdminServiceConfigPage  = Loadable({ loader: () => import('layers/marketplace/pages/admin/sport/AdminServiceConfigPage/AdminServiceConfigPage'), loading })
const AdminScheduleInputPage  = Loadable({ loader: () => import('layers/marketplace/pages/admin/sport/AdminScheduleInputPage/AdminScheduleInputPage'), loading })
const AdminScheduleConfigPage = Loadable({ loader: () => import('layers/marketplace/pages/admin/sport/AdminScheduleConfigPage/AdminScheduleConfigPage'), loading })

const AdminGroupsAddPage      = Loadable({ loader: () => import('layers/marketplace/pages/admin/sport/AdminGroupsAddPage/AdminGroupsAddPage'), loading })
const AdminGroupsConfigPage   = Loadable({ loader: () => import('layers/marketplace/pages/admin/sport/AdminGroupsConfigPage/AdminGroupsConfigPage'), loading })
const AdminLearnCalculatePage = Loadable({ loader: () => import('layers/marketplace/pages/admin/sport/AdminLearnCalculatePage/AdminLearnCalculatePage'), loading })
const AdminLearnTariffPage    = Loadable({ loader: () => import('layers/marketplace/pages/admin/sport/AdminLearnTariffPage/AdminLearnTariffPage'), loading })
const AdminLearnSubscribersPage = Loadable({ loader: () => import('layers/marketplace/pages/admin/sport/AdminLearnSubscribersPage/AdminLearnSubscribersPage'), loading })

// Admin edu
const AdminCatalogPage        = Loadable({ loader: () => import('layers/marketplace/pages/admin/edu/AdminCatalogPage/AdminCatalogPage'), loading })
const AdminConfigDaysPage     = Loadable({ loader: () => import('layers/marketplace/pages/admin/edu/AdminConfigDaysPage/AdminConfigDaysPage'), loading })
const AdminConfigAccessPage   = Loadable({ loader: () => import('layers/marketplace/pages/admin/edu/AdminConfigAccessPage/AdminConfigAccessPage'), loading })
const AdminConfigSchoolsPage  = Loadable({ loader: () => import('layers/marketplace/pages/admin/edu/AdminConfigSchoolsPage/AdminConfigSchoolsPage'), loading })
const AdminRegistryPage       = Loadable({ loader: () => import('layers/marketplace/pages/admin/edu/AdminRegistryPage/AdminRegistryPage'), loading })
const AdminReportFoodPage     = Loadable({ loader: () => import('layers/marketplace/pages/admin/edu/AdminReportFoodPage/AdminReportFoodPage'), loading })
const AdminConfigSchoolStagesPage  = Loadable({ loader: () => import('layers/marketplace/pages/admin/edu/AdminConfigSchoolStagesPage/AdminConfigSchoolStagesPage'), loading })
const AdminCancelFoodPage     = Loadable({ loader: () => import('layers/marketplace/pages/admin/edu/AdminCancelFoodPage/AdminCancelFoodPage'), loading })
const AdminOrderStatusPage    = Loadable({ loader: () => import('layers/marketplace/pages/admin/edu/AdminOrderStatusPage/AdminOrderStatusPage'), loading })

// Customer sport
const CustomerLearnPage       = Loadable({ loader: () => import('layers/marketplace/pages/customer/sport/CustomerLearnPage/CustomerLearnPage'), loading })
const CustomerOrderPage       = Loadable({ loader: () => import('layers/marketplace/pages/customer/sport/CustomerOrderPage/CustomerOrderPage'), loading })
const CustomerCancelPage      = Loadable({ loader: () => import('layers/marketplace/pages/customer/sport/CustomerCancelPage/CustomerCancelPage'), loading })
const CustomerTicketPage      = Loadable({ loader: () => import('layers/marketplace/pages/customer/sport/CustomerTicketPage/CustomerTicketPage'), loading })
const CustomerSchedulePage    = Loadable({ loader: () => import('layers/marketplace/pages/customer/sport/CustomerSchedulePage/CustomerSchedulePage'), loading })
const CustomerInfoPage        = Loadable({ loader: () => import('layers/marketplace/pages/customer/sport/CustomerInfoPage/CustomerInfoPage'), loading })

// Customer edu
const CustomerOrderFoodPage   = Loadable({ loader: () => import('layers/marketplace/pages/customer/edu/CustomerOrderFoodPage/CustomerOrderFoodPage'), loading })
const CustomerCancelFoodPage  = Loadable({ loader: () => import('layers/marketplace/pages/customer/edu/CustomerCancelFoodPage/CustomerCancelFoodPage'), loading })

// Customer movie
const CustomerAreaPage   = Loadable({ loader: () => import('layers/marketplace/pages/customer/movie/CustomerAreaPage/CustomerAreaPage'), loading })
const CustomerMoviePage   = Loadable({ loader: () => import('layers/marketplace/pages/customer/movie/CustomerMoviePage/CustomerMoviePage'), loading })

// Cashier sport
const CashierLearnPage        = Loadable({ loader: () => import('layers/marketplace/pages/cashier/sport/CashierLearnPage/CashierLearnPage'), loading })
const CashierLearnSalePage    = Loadable({ loader: () => import('layers/marketplace/pages/cashier/sport/CashierLearnSalePage/CashierLearnSalePage'), loading })
const CashierCancelPage       = Loadable({ loader: () => import('layers/marketplace/pages/cashier/sport/CashierCancelPage/CashierCancelPage'), loading })
const CashierTicketPage       = Loadable({ loader: () => import('layers/marketplace/pages/cashier/sport/CashierTicketPage/CashierTicketPage'), loading })
const CashierSchedulePage     = Loadable({ loader: () => import('layers/marketplace/pages/cashier/sport/CashierSchedulePage/CashierSchedulePage'), loading })

// Cashier sport
const CashierRegistryFoodPage = Loadable({ loader: () => import('layers/marketplace/pages/cashier/edu/CashierRegistryFoodPage/CashierRegistryFoodPage'), loading })
const CashierControlFoodPage  = Loadable({ loader: () => import('layers/marketplace/pages/cashier/edu/CashierControlFoodPage/CashierControlFoodPage'), loading })
const CashierConfigFoodPage   = Loadable({ loader: () => import('layers/marketplace/pages/cashier/edu/CashierConfigFoodPage/CashierConfigFoodPage'), loading })
const CashierCancelFoodPage   = Loadable({ loader: () => import('layers/marketplace/pages/cashier/edu/CashierCancelFoodPage/CashierCancelFoodPage'), loading })
const CashierSalesFoodPage    = Loadable({ loader: () => import('layers/marketplace/pages/cashier/edu/CashierSalesFoodPage/CashierSalesFoodPage'), loading })

const LoginPage               = Loadable({ loader: () => import('layers/marketplace/pages/LoginPage/LoginPage'), loading })


export default (links) => (
  <Route>
    <Route path={links.login} component={LoginPage} />

    <Route components={PageLayout}>

      <Route path={links.order} component={CustomerOrderPage} />
      <Route path={links.privacy} component={PrivacyPage} />

      {/* No Authorisation */}
      <Route component={AreaLayout}>

        {/*Authorisation */}
        <Route path={links.root} component={AuthLayout} />

        <Route component={AccessLayout}>
          {/* Admin */}
          <Route component={AdminLayout}>
            <Route path={links.admin.areaConfig} component={AdminAreaConfigPage} />

            {/* Sport */}
            <Route path={links.admin.learn.root} component={AdminLearnPage} />
            <Route path={links.admin.learn.groupsConfig} component={AdminGroupsConfigPage} />
            <Route path={links.admin.learn.groupsAdd} component={AdminGroupsAddPage} />
            <Route path={links.admin.learn.calculate} component={AdminLearnCalculatePage} />
            <Route path={links.admin.learn.tariff} component={AdminLearnTariffPage} />
            <Route path={links.admin.learn.subscribers} component={AdminLearnSubscribersPage} />

            <Route path={links.admin.report} component={AdminReportPage} />
            <Route path={links.admin.ticket} component={AdminTicketPage} />
            <Route path={links.admin.tariffConfig} component={AdminTariffPage} />
            <Route path={links.admin.scheduleView} component={AdminSchedulePage} />
            <Route path={links.admin.scheduleInput} component={AdminScheduleInputPage} />
            <Route path={links.admin.scheduleConfig} component={AdminScheduleConfigPage} />
            <Route path={links.admin.statisticsConfig} component={AdminStatisticsPage} />
            <Route path={links.admin.serviceConfig} component={AdminServiceConfigPage} />

            {/* Edu */}
            <Route path={links.admin.bulkCancel} component={AdminCancelFoodPage} />
            <Route path={links.admin.orderStatus} component={AdminOrderStatusPage} />
            <Route path={links.admin.catalog} component={AdminCatalogPage} />
            <Route path={links.admin.configDays} component={AdminConfigDaysPage} />
            <Route path={links.admin.configAccess} component={AdminConfigAccessPage} />
            <Route path={links.admin.configSchools} component={AdminConfigSchoolsPage} />
            <Route path={links.admin.configSchoolStages} component={AdminConfigSchoolStagesPage} />
            <Route path={links.admin.registry} component={AdminRegistryPage} />
            <Route path={links.admin.reportEdu} component={AdminReportFoodPage} />
          </Route>

          {/* Cashier */}
          <Route component={CashierLayout}>
            {/* Sport */}
            <Route path={links.cashier.learn.root} component={CashierLearnPage} />
            <Route path={links.cashier.learn.sale} component={CashierLearnSalePage} />

            <Route path={links.cashier.cancel} component={CashierCancelPage} />
            <Route path={links.cashier.ticket} component={CashierTicketPage} />
            <Route path={links.cashier.schedule} component={CashierSchedulePage} />

            {/* Edu */}
            <Route path={links.cashier.registry} component={CashierRegistryFoodPage} />
            <Route path={links.cashier.control} component={CashierControlFoodPage} />
            <Route path={links.cashier.config} component={CashierConfigFoodPage} />
            <Route path={links.cashier.cancelFood} component={CashierCancelFoodPage} />
            <Route path={links.cashier.sales} component={CashierSalesFoodPage} />
          </Route>

          {/* Customer */}
          <Route component={CustomerLayout}>
            {/* Sport */}
            <Route path={links.customer.learn} component={CustomerLearnPage} />
            <Route path={links.customer.cancel} component={CustomerCancelPage} />
            <Route path={links.customer.ticket} component={CustomerTicketPage} />
            <Route path={links.customer.schedule} component={CustomerSchedulePage} />
            <Route path={links.customer.info} component={CustomerInfoPage} />

            {/* Edu */}
            <Route path={links.customer.orderFood} component={CustomerOrderFoodPage} />
            <Route path={links.customer.cancelFood} component={CustomerCancelFoodPage} />

          </Route>
        </Route>
      </Route>
      {/* Movie */}
      <Route path={links.customer.area} component={CustomerAreaPage} />
      <Route path={links.customer.movie} component={CustomerMoviePage} />

    </Route>

    <Redirect path={`${links.root}/*`} to={links.root} />
  </Route>
)
